import { H3 } from "@/shared/components/typography";
import { Building } from "../types/building";
import t from "@/lang/lang";
import { DeleteBuildingButton } from "./delete-building-button";
import { PersistenceContextProvider } from "@/shared/lib/persistence-state/provider";
import { BuildingAddressEditGroup } from "./building-address-edit-group";
import { PersistenceStateUsingContext } from "@/shared/lib/persistence-state/persistence-state-info";
import { BuildingAreasTables } from "./building-areas-tables";

export function BuildingDetailsPage({
  customerId,
  building,
  onDeleteBuilding,
}: {
  customerId: string;
  building: Building;
  onDeleteBuilding: (buildingId: string) => void;
}) {
  return (
    <div className="grid gap-6">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
        <div className="grid gap-1">
          <H3>{building.name}</H3>
          <p className="text-muted-foreground text-sm">
            {t(
              "Hier werden die Adresse sowie Ebenen und Bereiche dieses Gebäudes angezeigt und verwaltet.",
            )}
          </p>
        </div>
        <DeleteBuildingButton
          building={building}
          onDeleteBuilding={onDeleteBuilding}
          variant="button"
        />
      </div>

      <PersistenceContextProvider>
        <div className="grid gap-3">
          <BuildingAddressEditGroup
            buildingId={building.id}
            customerId={customerId}
            name={building.name}
            address={building.address}
            addressKey={building.addressKey}
            topRightContent={<PersistenceStateUsingContext className="mr-2" />}
          />
        </div>
      </PersistenceContextProvider>

      <div
        key={building.id}
        className="bg-card grid gap-5 rounded-xl border p-4 sm:p-5"
      >
        <div className="grid gap-1">
          <div className="text-lg font-semibold">
            {t("Ebenen und Bereiche")}
          </div>
          <p className="text-muted-foreground text-sm">
            {t(
              "Hier werden die Ebenen und Bereiche dieses Gebäudes angezeigt und verwaltet.",
            )}
          </p>
        </div>
        <PersistenceContextProvider>
          <BuildingAreasTables building={building} />
        </PersistenceContextProvider>
      </div>
    </div>
  );
}
